'use strict';

var _ = require('lodash');
var ClassIndicesService = function ClassIndicesService(configurationService) {
  function prepareCabinIndices(market) {
    var classesDefaultConfig = configurationService.getClassGroupConfigDefault();
    var marketClasses = configurationService.getClassGroupConfigByMarket(market);
    return _.chain(marketClasses).concat(classesDefaultConfig).uniqBy('cabinCode').keyBy('cabinCode').mapValues('cabinIndex').value();
  }
  function prepareClassIndices(market) {
    var classesDefaultConfig = configurationService.getClassGroupConfigDefault();
    var marketClasses = configurationService.getClassGroupConfigByMarket(market);
    return _.chain(marketClasses).concat(classesDefaultConfig).uniqBy('className').sortBy(['classIndex', 'className']).keyBy('className').mapValues('classIndex').value();
  }
  function prepareClassGroupIndices(classGroupIndicesKey) {
    var classesDefaultConfig = configurationService.getClassGroupConfigDefault();
    var marketClasses = configurationService.getClassGroupConfigByMarket(classGroupIndicesKey);
    return _.chain(marketClasses).concat(classesDefaultConfig).uniqBy('classGroup').sortBy(['cabinIndex', 'classGroup']).keyBy('classGroup').mapValues('cabinIndex').value();
  }
  return {
    prepareClassIndices: prepareClassIndices,
    prepareClassGroupIndices: prepareClassGroupIndices,
    prepareCabinIndices: prepareCabinIndices
  };
};
ClassIndicesService.$inject = ['ConfigurationService'];
module.exports = ClassIndicesService;